<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component
        :is="Component"
        v-if="$route.meta.keepAlive"
        :key="$route.meta.usePathKey ? $route.path : undefined"
      ></component>
    </keep-alive>
    <component
      :is="Component"
      v-if="!$route.meta.keepAlive"
      :key="$route.meta.usePathKey ? $route.path : undefined"
    ></component>
  </router-view>
</template>
